import type { ValidationError } from "@common/types";

export class CriterionCreatorViewModel
{
    isOpen = false;

    parentId: number | null = null;
    parentName = '';

    name = '';
    description = '';
    nameError: string | null = null;

    show(parentId: number, parentName: string)
    {
        this.parentId = parentId;
        this.parentName = parentName;
        this.isOpen = true;
    }

    close()
    {
        this.isOpen = false;
        this.reset();
        this.parentId = null;
        this.parentName = '';
    }

    displayValidationErrors(errors: ValidationError[])
    {
        const nameError = errors.find(e => e.ErrorCode?.startsWith("Name."));
        this.nameError = nameError?.Error ?? null;
    }

    clearValidationErrors()
    {
        this.nameError = null;
    }

    reset()
    {
        this.name = '';
        this.description = '';
        this.clearValidationErrors();
    }
}
